import { render, staticRenderFns } from "./ServiceTypeDelete.vue?vue&type=template&id=0487082c&"
import script from "./ServiceTypeDelete.vue?vue&type=script&lang=js&"
export * from "./ServiceTypeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports